import script from "./TextareaFacade.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaFacade.vue?vue&type=script&setup=true&lang=js"

import "./TextareaFacade.vue?vue&type=style&index=0&id=61e46ec8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e46ec8"]])

export default __exports__